import React from 'react';
import { BaseComponent } from 'components/BaseComponent';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import styled from 'styled-components';
import { createStructuredSelector } from 'reselect';
import { HBox } from '../../../../components/Box';
import { VehiclePropertyLoadable } from '../../../../modules/Vehicles/components/VehiclePropertyLoadable';
import { deleteVehicleProperty, setVehicleProperty } from '../../../../modules/Vehicles/actions';
import { COLOR_PRIMARY_1 } from '../../../../vars';
import { Check, Times } from '../../../../components/Icon';

const Container = styled.div`
  .modal-inner {
  }

  .icon-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;

    font-size: medium;
  }
  .manco-list > div {
  }

  .triple {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 6px 0;

    .btn-check:checked + .btn {
      background-color: var(--color-new-secondary);
      border-color: var(--color-new-secondary);
      color: #fff; /* optioneel: tekst wit voor contrast */
    }
    .btn-check:not(:checked) + .btn {
      border-color: var(--color-new-primary);
      color: var(--color-new-primary);
    }

    transition: opacity 0.2s;
    .check {
      transition: opacity 0.2s;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 24px;
      height: 24px;
      border: none;
      color: ${COLOR_PRIMARY_1};

      text-align: center;
      font-size: medium;
      line-height: 20px;
    }

    &.triple-0 {
      .btn.btn-danger,
      .btn.btn-outline-primary.active {
        background-color: #e45c52;
        border-color: #e45c52;
        color: white;
      }
    }
    &.triple-1 {
      .check {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: medium;
        border: none;
        color: white;
      }
    }
    &.triple-2 {
      .check {
        border: 1px solid red;
        text-align: center;
        color: red;
      }
    }

    &.disabled {
      opacity: 0.4;
      .check {
        opacity: 0;
      }
    }
    @media (max-width: 425px) {
      font-size: 12px;
    }
  }
`;

const STATE = {
  sort: false,
};

/* eslint-disable react/prefer-stateless-function */
class DoubleCheckComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  propertyValue(name) {
    return this.props.vehicle[name];
  }

  renderDoubleCheck(name) {
    let val = this.propertyValue(name);
    let state = val === undefined || val === null ? null : val == 1 ? 1 : 0;

    if (this.props.singleCheck) {
      return (
        <HBox vCenter key={name}>
          <div className={`triple triple-${state} ${this.props.work ? 'disabled' : ''}`}>
            <div className="label">{this.lbl(`vehicle.property.${name}`)}</div>
            <VehiclePropertyLoadable name={name}>
              <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
                <input
                  type="radio"
                  className="btn-check"
                  name={`btnradio-${name}`}
                  id={`btnradio1-${name}`}
                  autoComplete="off"
                  checked={state === 1}
                  onClick={() => {
                    state === 1 ? this.props.deleteProperty(name) : this.props.setProperty(name, 1);
                  }}
                  onChange={() => {}}
                />
                <label className={`btn btn-outline-primary ${state === 1 ? 'active' : ''}`} htmlFor={`btnradio1-${name}`}>
                  {this.props.yesNo ? (
                    <div className="icon-wrapper">
                      <Check />
                      <span>Ja</span>
                    </div>
                  ) : this.props.customYes ? (
                    this.props.customYes
                  ) : (
                    <div className="icon-wrapper">
                      <Check />
                      <span>Ja</span>
                    </div>
                  )}
                </label>
              </div>
            </VehiclePropertyLoadable>
          </div>
        </HBox>
      );
    }

    return (
      <HBox vCenter key={name}>
        <div className={`triple triple-${state} ${this.props.work ? 'disabled' : ''}`}>
          <div className="label">{this.lbl(`vehicle.property.${name}`)}</div>
          <VehiclePropertyLoadable name={name}>
            <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`}
                id={`btnradio1-${name}`}
                autoComplete="off"
                checked={state === 1}
                onClick={() => {
                  state === 1 ? this.props.deleteProperty(name) : this.props.setProperty(name, 1);
                }}
                onChange={() => {}}
              />
              <label className={`btn btn-outline-primary ${state === 1 ? 'active' : ''}`} htmlFor={`btnradio1-${name}`}>
                {this.props.yesNo ? (
                  <div className="icon-wrapper">
                    <Check />
                    <span>Ja</span>
                  </div>
                ) : this.props.customYes ? (
                  this.props.customYes
                ) : (
                  <div className="icon-wrapper">
                    <Check />
                    <span>Ja</span>
                  </div>
                )}
              </label>

              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`}
                id={`btnradio2-${name}`}
                autoComplete="off"
                checked={state === 0}
                onClick={() => {
                  state === 0 ? this.props.deleteProperty(name) : this.props.setProperty(name, 0);
                }}
                onChange={() => {}}
              />
              <label
                className={`btn ${state === 0 ? 'btn-danger text-white active' : 'btn-outline-primary'}`}
                htmlFor={`btnradio2-${name}`}
              >
                {this.props.yesNo ? (
                  <div className="icon-wrapper">
                    <Times /> <span>Nee</span>
                  </div>
                ) : this.props.customNo ? (
                  this.props.customNo
                ) : (
                  <div className="icon-wrapper red">
                    <Times /> <span>Nee</span>
                  </div>
                )}
              </label>
            </div>
          </VehiclePropertyLoadable>
        </div>
      </HBox>
    );
  }

  render() {
    return <Container>{this.renderDoubleCheck(this.props.name)}</Container>;
  }
}

DoubleCheckComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setProperty(name, value) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, name, value));
    },
    deleteProperty(name) {
      dispatch(deleteVehicleProperty(ownProps.vehicle.id, name));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const DoubleCheck = compose(withConnect, withRouter)(DoubleCheckComp);
